import * as React from "react";

const Lock: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g clip-path="url(#clip0_4534_18342)">
                <path d="M15 6.66658H14.1666V4.99992C14.1666 2.69992 12.3 0.833252 9.99998 0.833252C7.69998 0.833252 5.83331 2.69992 5.83331 4.99992V6.66658H4.99998C4.08331 6.66658 3.33331 7.41658 3.33331 8.33325V16.6666C3.33331 17.5833 4.08331 18.3333 4.99998 18.3333H15C15.9166 18.3333 16.6666 17.5833 16.6666 16.6666V8.33325C16.6666 7.41658 15.9166 6.66658 15 6.66658ZM7.49998 4.99992C7.49998 3.61659 8.61665 2.49992 9.99998 2.49992C11.3833 2.49992 12.5 3.61659 12.5 4.99992V6.66658H7.49998V4.99992ZM15 16.6666H4.99998V8.33325H15V16.6666ZM9.99998 14.1666C10.9166 14.1666 11.6666 13.4166 11.6666 12.4999C11.6666 11.5833 10.9166 10.8333 9.99998 10.8333C9.08331 10.8333 8.33331 11.5833 8.33331 12.4999C8.33331 13.4166 9.08331 14.1666 9.99998 14.1666Z" fill="currentColor"/>
            </g>
            <defs>
                <clipPath id="clip0_4534_18342">
                    <rect width="20" height="20" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default React.memo(Lock);